import { Table, Input, Button, Modal, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { httpUrl, httpPost } from "../../api/httpClient";
import { deletedCode, loginTypeCode } from "../../lib/util/codeUtil"
import UserDialog from "../../components/modal/UserDialog";
import { reactLocalStorage } from "reactjs-localstorage";
import con from '../../const';
import {
    formatDate,
    amountFormat,
    coinMultiFormat,
    coinDivideFormat
  } from "../../lib/util/numberUtil";
import { fetchServerWallet } from "../../lib/util/walletInfoUtil";

const Search = Input.Search;

const errorText = (message) => (
    <span style={{ color: "#cf1322" }}>{message}</span>
);

const AssetWithdraw = () => {
    const userInfo = reactLocalStorage.getObject(con.appName + "#loginInfo");
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [serverWalletInfo, setServerWalletInfo] = useState({});
    const [feeWalletInfo, setFeeWalletInfo] = useState({});
    const [walletLoading, setWalletLoading] = useState(true);
    const [serverWalletError, setServerWalletError] = useState("");
    const [feeWalletError, setFeeWalletError] = useState("");
    
    const [list, setList] = useState([]);
    const [otpKey, setOtpKey] = useState("")
    const [password, setPassword] = useState('');
    const [amount, setAmount] = useState('');
    const [withdrawAddress, setWithdrawAddress] = useState('');

    useEffect(()=>{
        getWalletInfo();
    },[])

    const getWalletInfo = async() => {
        setWalletLoading(true);
        setServerWalletError("");
        setFeeWalletError("");
        try {
            const usdtWallet = await fetchServerWallet(401);
            setServerWalletInfo(usdtWallet);
        } catch (e) {
            console.error(e);
            setServerWalletInfo({});
            setServerWalletError("잔액 조회에 실패했습니다.");
        }
        try {
            const bnbWallet = await fetchServerWallet(4);
            setFeeWalletInfo(bnbWallet);
        } catch (e) {
            console.error(e);
            setFeeWalletInfo({});
            setFeeWalletError("잔액 조회에 실패했습니다.");
        }
        setWalletLoading(false);
    };

    const renderWalletAddress = (error, address) => {
        if (walletLoading) return "조회 중...";
        if (error) return errorText(error);
        if (!address) return errorText("잔액 조회에 실패했습니다.");
        return address;
    };

    const renderWalletAmount = (error, value, coinType, suffix) => {
        if (walletLoading) return "조회 중...";
        if (error) return errorText(error);
        if (value === undefined || value === null || !Number.isFinite(Number(value))) {
            return errorText("잔액 조회에 실패했습니다.");
        }
        return `${amountFormat(value, coinType)}${suffix}`;
    };

    const renderUsdtBalance = () => {
        if (walletLoading) return "조회 중...";
        if (serverWalletError) return errorText(serverWalletError);
        if (
            serverWalletInfo.balance === undefined ||
            serverWalletInfo.balance === null ||
            !Number.isFinite(Number(serverWalletInfo.balance))
        ) {
            return errorText("잔액 조회에 실패했습니다.");
        }
        return `${amountFormat(serverWalletInfo.balance, 401)} USDT (사용불가: ${amountFormat(serverWalletInfo.lockBalance, 401)} USDT)`;
    };

    const handleTableChange = (page) => {
        setPagination({
            ...pagination,
            current: page.current
        });
    };

    const onsubmit = async () => {
        if (walletLoading || serverWalletError) {
            alert("잔액 조회에 실패했습니다. 새로고침 후 다시 시도해주세요.");
            return;
        }
        if (!amount) {
            alert("수량을 입력해주세요.");
            return;
        }
        if (parseFloat(amount) <= 0) {
            alert("출금수량은 0보다 커야 합니다.");
            return;
        }
        if (!withdrawAddress) {
            alert("출금주소를 입력해주세요.");       
            return;           
        }
        if (!password) {
            alert("계정 비밀번호를 입력해주세요.");
            return;
        }
        if (!otpKey) {
            alert("OTP 인증번호를 입력해주세요.");
            return;
        }
        
        // 사용 가능한 잔액 계산 (전체 잔액 - 사용불가 잔액)
        const availableBalance = serverWalletInfo.balance - (serverWalletInfo.lockBalance || 0);
        const requestedAmount = coinMultiFormat(amount, 401);
        console.log("availableBalance", availableBalance);
        console.log("requestedAmount", requestedAmount);
        if (requestedAmount > availableBalance) {
            alert(`출금수량이 사용 가능한 잔액(${amountFormat(availableBalance, 401)} USDT)을 초과합니다.`);
            return;
        }

//0xeeE866E14eC60b0cC6eF150c69C307b5175f240B
        const withdrawalReq= {
            coinType: 401,
            to: withdrawAddress,
            amount: coinMultiFormat(amount, 401),
            password,
            otp: otpKey
        };
        try {
            const res = await httpPost(httpUrl.withdrawSingle, [],withdrawalReq);
            console.log("Withdrawal API response:", res);

            if (res.data == 'SUCCESS') {
                setWithdrawAddress('');
                setPassword('');
                setOtpKey('');
                setAmount('');
                alert('출금요청을 완료하였습니다.');
            }
            else if (res.data == 'AUTH_FAIL') alert('인증에 실패하였습니다')
            else if (res.data == 'FAIL') alert('실패하였습니다')
        } catch (error) {
            console.error("Withdrawal API error:", error);
            alert("출금 실패. 다시 시도해주세요.");
        }
    }

    return (
        <div id="setting" className="main">
            <div className="main-title">자산 인출</div>
            <div className="container">
                <div className="background-container">
                    <div className="container">
                            <div className="title">
                                집금계좌
                            </div>
                            <div className="content">
                                {renderWalletAddress(serverWalletError, serverWalletInfo.address)}
                            </div>
                        </div>

                        <div className="container">
                            <div className="title">
                                잔액
                            </div>
                            <div className="content">
                                {renderUsdtBalance()}
                            </div>
                        </div>
                        <div className="container">
                            <div className="title">
                                수수료계좌(BNB)
                            </div>
                            <div className="content">
                                {renderWalletAddress(feeWalletError, feeWalletInfo.address)}
                            </div>
                        </div>

                        <div className="container">
                            <div className="title">
                                수수료계좌 잔액
                            </div>
                            <div className="content">
                            {renderWalletAmount(feeWalletError, feeWalletInfo.balance, 4, " BNB")}
                            </div>
                        </div>

                        <div className="container">
                            <div className="title">
                                출금주소
                            </div>
                            <Input
                                    name="title"
                                    placeholder="출금 주소를 입력해주세요"
                                    className="input"
                                    value={withdrawAddress}
                                    onChange={(e) => setWithdrawAddress(e.target.value)}
                                />
                        </div>
                        <div className="container">
                            <div className="title">
                                출금수량
                            </div>
                            <Input
                                    name="amount"
                                    placeholder="출금 수량을 입력해주세요"
                                    className="input"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                />
                        </div>

                        <div className="container">
                            <div className="title">
                                비밀번호
                            </div>
                            <Input
                                className="input"
                                type="password"
                                placeholder="계정 비밀번호를 입력해주세요"
                                value={password}
                                onChange={(e) => {
                                setPassword(e.target.value);
                                }}              
                            />
                        </div>
                        <div className="container">
                            <div className="title">
                                OTP 인증번호
                            </div>
                            <Input
                                className="input"
                                type="password"
                                placeholder="OTP 번호를 입력해주세요"
                                value={otpKey}
                                onChange={(e) => {
                                setOtpKey(e.target.value);
                                }}
                            />
                        </div>

                        <div className="container-btn">
                            <Button
                                className="float-btn"
                                onClick={onsubmit}
                            >
                                출금
                            </Button>
                        </div>

                </div>
            </div>

        </div>
    );

}

export default AssetWithdraw;
